import React, { Suspense } from "react"
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

const ViewMain = React.lazy(() => import("./views"));

function App() {
  return (
    <Suspense fallback={<div className="loading" />}>
      <Router>
        <Routes>
          <Route exact path="*" element={<ViewMain />} />
        </Routes>
      </Router>
    </Suspense>
  );
}

export default App;
